(ns ui.components.input.boolean
  (:require
   [cljs-uuid-utils.core :as uuid]
   [common.localization :as loc]
   [frontend.utils :as fu]))

(defn view
  [{:keys [value radio-name on-change true-label false-label
           disabled? _on-focus class _on-blur show-clear?]}]
  (let [radio-name (or radio-name
                       (uuid/uuid-string 12))]
    [:div
     {:class-name (fu/cs "pt-1 flex flex-row justify-start items-center gap-3"
                         class)}
     [:label
      {:class-name "flex items-center gap-2"}
      [:input
       {:type      "radio"
        :name      radio-name
        :class "appearance-none h-4 w-4 bg-input-light border border-solid border-input-gloomy-border-light text-input-gloomy-text focus:ring-indigo-600 checked:bg-input-light checked:p-1 checked:border-4 checked:border-solid checked:border-input-gloomy rounded-full"
        :disabled  disabled?
        :checked   (true? value)
        :on-change (fn [_e]
                     (on-change true))}]
      [:span (or true-label
                 (loc/tr :true))]]
     [:label
      {:class-name "flex items-center gap-2"}
      [:input
       {:type      "radio"
        :class "appearance-none h-4 w-4 bg-input-light border border-solid border-input-gloomy-border-light text-input-gloomy-text focus:ring-indigo-600 checked:bg-input-light checked:p-1 checked:border-4 checked:border-solid checked:border-input-gloomy rounded-full"
        :name      radio-name
        :disabled  disabled?
        :checked   (false? value)
        :on-change (fn [_e]
                     (on-change false))}]
      [:span (or false-label
                 (loc/tr :false))]]

     (when (and show-clear?
                (boolean? value))
       [:i.fal.fa-times-circle.text-danger
        {:on-click (fn [_e]
                     (on-change nil))}])]))
